/**
 * @licence Copyright © 2019 Mercury Redstone BV, all rights reserved
 */
import { useTranslation } from 'react-i18next';
import { Icon } from './Icon';
import { Title } from './Title';

const RebalanceFinalised = () => {
  const { t } = useTranslation();

  return (
    <>
      <Icon type={'successGreen'} />
      <Title>{t('NOTIFICATION_REBALANCE_IN_FINALISED__title')}</Title>
    </>
  );
};

export { RebalanceFinalised };
